<ui-card class="w-full min-w-52">
	<h3 card-header class="text-xl font-medium capitalize">Add Fields</h3>

	<div class="flex flex-col gap-6 relative" card-content>
		<ui-select
			label="Select Signer"
			[options]="options()"
			[selected]="selected_()"
			(selectedChange)="selectedOverride_.set($event)"
		/>

		<fieldset
			class="flex flex-col pt-2 gap-2 w-full *:w-full [&>legend]:text-gray-700 [&>legend]:text-sm"
		>
			<legend>Settings</legend>
			<div class="flex justify-between items-center flex-wrap gap-1">
				<div class="flex items-center justify-start gap-1">
					<p class="text-sm text-gray-700">Require hand-drawn signature</p>
					<i-tabler
						name="help-circle"
						class="size-4 text-gray-300"
						matTooltip="When enabled, signers are required to draw their signature in each field. Typed or saved signatures will not be allowed."
					/>
				</div>
				<ui-toggle [type]="TOGGLE_TYPES.ICON_DEFAULT" [(ngModel)]="drawOnly_" />
			</div>
		</fieldset>

		<fieldset class="flex pt-2 gap-2 w-full flex-col lg:flex-row lg:flex-wrap">
			<legend class="text-gray-700 text-sm">Select Field</legend>
			@if (selected_()) {
				@for (option of buttonBlockList_(); track option.label) {
					<app-block-button
						class="lg:flex-[1_1_calc(50%-0.5rem)] lg:last-of-type:flex-[0_1_calc(50%-0.25rem)]"
						[ariaLabel]="option.ariaLabel"
						[iconName]="option.iconName"
						[label]="option.label | titlecase"
						[variant]="variant()"
						[isSelected]="selectedBlockType_() === option.type"
						[draggable]="true"
						(clicked)="onBlockButtonClick($event, option.type)"
						(dragstart)="onDragStart($event, option.type)"
						(dragend)="onDragEnd()"
					/>
				}
			}
		</fieldset>

		<!-- Preview elements  -->
		@if (selected_()) {
			@for (option of buttonBlockList_(); track option.label) {
				@let isActiveClickPreview =
					selectedBlockInfo_()?.type === option.type && !isDragging_();
				<div
					#dragPreview
					class="pointer-events-none"
					[ngClass]="isActiveClickPreview ? 'fixed z-50' : 'absolute -z-10'"
					[style.left.px]="isActiveClickPreview ? mousePosition_().x : null"
					[style.top.px]="isActiveClickPreview ? mousePosition_().y : null"
					[attr.data-block-type]="option.type"
				>
					<app-e-signing-canvas-block
						[blockType]="option.type"
						[variant]="variant()"
						[draggable]="false"
						[disabled]="true"
					/>
				</div>
			}
		}
	</div>
</ui-card>
